export function isTerminateValue(value?: any): boolean {
  if (typeof value !== 'object' || value === null) return true
  if (value.__r_proxy_raw !== undefined || value.__rr_flags !== undefined)
    return false
  return (
    value.__v_skip !== undefined ||
    value._isAMomentObject !== undefined ||
    value.$$typeof !== undefined ||
    value.$isDayjsObject !== undefined
  )
}
